import React, { useEffect, useState } from "react";
import { CustomButton } from "../../../../shared/CustomButton";
import CustomModal from "../../../../shared/CustomModal";
// import axios from "axios";
import axiosInstance, { baseUrl } from "../../../../config/axios";
import NewMultiSearchAndSelect from "../../../../shared/NewMultisearchSelect";
import { useFormik } from "formik";
import { Button, IconButton } from "@mui/material";
import { toast } from "react-toastify";
import { Edit } from "@mui/icons-material";

const CategoryMap = ({ brandData, ProductDataList: Refech }) => {
  const [open, setOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const [productData, setProductData] = useState([]);

  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);

  const formik = useFormik({
    initialValues: {
      category_id:
        brandData?.map_category?.map((i) => ({
          value: i?.id,
          label: i?.title,
        })) || [],
    },

    enableReinitialize: true,
    onSubmit: (values) => {
      const payload = {
        map_category: values?.category_id?.map((i) => i?.value),
        brand_id: brandData?.id,
      };
      setLoading(true);
      axiosInstance
        .patch(`api/admin/multivendor-update-show-brand-list/`, payload, {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        })
        .then((response) => {
          // setStore(response?.data.store_list_data);

          if (response?.data?.response_code === 200) {
            toast.success(response.data.message);
            Refech();
            setLoading(false);
            setOpen(false);

            formik.resetForm();
          } else {
            toast.error(response.data.message);
          }
        })
        .catch((error) => {
          console.log("error page", error.response);
          console.log(error);
          setLoading(false);
        });
    },
  });
  const superuserId = "true";
  const ProductDataList = () => {
    setLoading1(true);
    superuserId !== "true"
      ? axiosInstance
          .post(
            `api/admin/multivendor-show-main-category-list/?search=${searchQuery}`,
            {},
            {
              headers: {
                Token: localStorage.getItem("Token"),
              },
            },
          )
          .then((response) => {
            console.log(
              "category list data===>",
              response?.data?.main_category_data,
            );

            setProductData(response?.data);
            setLoading1(false);
          })
          .catch((error) => {
            console.log("", error);
            setLoading1(false);
          })
      : axiosInstance
          .post(
            `api/admin/multivendor-show-main-category-list/?search=${searchQuery}`,
            { search: searchQuery },
            {
              headers: {
                Token: localStorage.getItem("Token"),
              },
            },
          )
          .then((response) => {
            setProductData(response?.data);
            setLoading1(false);
          })
          .catch((error) => {
            console.log("", error);
            setLoading1(false);
          });
  };
  useEffect(() => {
    if (open) {
      ProductDataList();
    }
  }, [searchQuery, open]);

  const categoryDataOptions = productData?.main_category_data?.map((i) => ({
    value: i?.id,
    label: i?.category,
  }));

  return (
    <>
      <IconButton
        onClick={() => setOpen(true)}
        size="small"
        variant="contained"
        color="warning"
      >
        <Edit />
      </IconButton>

      <CustomModal title="Category" open={open} setOpen={setOpen}>
        <form
          onSubmit={formik.handleSubmit}
          className="space-y-5 flex items-center flex-col"
        >
          <NewMultiSearchAndSelect
            loading={loading1}
            options={categoryDataOptions || []}
            id={"category_id"}
            name={"category_id"}
            placeholder={"Search And Select Category"}
            formik={formik}
            setSearchValue={setSearchQuery}
            className={"!w-full"}
          />

          <Button type="submit" variant="contained" color="success">
            {loading ? "Loading..." : " Save"}
          </Button>
        </form>
      </CustomModal>
    </>
  );
};

export default CategoryMap;
